<section id="about" >
    <div class="container">
  
    <header class="section-header">
      <h1 style="text-align: center;" class="section-title">Utility Billing Software</h1>
    </header>
  
    <div class="row row-eq-height justify-content-center">
        <div class="row about-container">
          
            <div class="col-lg-6 background order-lg-2 order-1 wow fadeInUp">
       
              <div class="icon-box wow fadeInUp">
                <div class="icon"><i class="fa fa-check-circle"></i></div>
                <h4 class="title"><a href="">Masters</a></h4>
                <p class="description"> State Creation.
                     City Creation.
                     Region Creation.
                     Area/Route Creation.
                     Society Creation.
                     Employee Creation.
                     Agency Creation.
                     Sector Type Creation.
                     Customer Creation.
                     Meter Connection.
                     Ledger Creation.
                     Industrial Code
                     Commercial Code</p>
              </div>
  
              <div class="icon-box wow fadeInUp" data-wow-delay="0.2s">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                <h4 class="title"><a href="">Voucher Types and Voucher Entry</a></h4>
                <p class="description"> Receipt Entry
                     Payment Entry.
                     Domestic Bill Entry.
                     Journal Entry.
                     Multiple Bill Entry.
                     Cheque Bounce Entry</p>
              </div>
  
              <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                <h4 class="title"><a href="">Utilities</a></h4>
                <p class="description"> User Creation and Security Module.
                     Back Up.
                     Upload/Download data.
                     Import Customer.
                     Import Meter Connection.
                     Import Bill Entry.
                     Import Receipt Entry.
                     Import Installment.
                  </p>
              </div>
  
              <div class="icon-box wow fadeInUp">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                  <h4 class="title"><a href="">Reports</a></h4>
                  <p class="description">Customer Reports
                       Customer Ledger(Outstanding)
                       Agency wise Customer Book
                       Date wise Balance Sheet
                       All Customer Outstanding
                       City wise Customer Book
                       Area wise Customer Book
                       Supervisor wise Customer Book
                       Agent wise Customer Book </p>
                </div>
                              
            </div>
           
  
  
            <div class="col-lg-6 background order-lg-2 order-1 wow fadeInUp">
             
           
                <div class="icon-box wow fadeInUp">
                    <div class="icon"><i class="fa fa-check-circle"></i></div>
                    <h4 class="title"><a href="">Reports</a></h4>
                    <p class="description">Customer Reports
                         Customer Ledger(Outstanding)
                         Agency wise Customer Book
                         Date wise Balance Sheet
                         All Customer Outstanding
                         City wise Customer Book
                         Area wise Customer Book
                         Supervisor wise Customer Book
                         Agent wise Customer Book </p>
                  </div>
    
                  <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                      <div class="icon"><i class="fa fa-check-circle"></i></div>
                      <h4 class="title"><a href="">Registers</a></h4>
                      <p class="description"> Sales Register
                           Receipt Register
                           Society wise Bill Summary
                           Stop Reading Report
                           Security Deposit Details
                           Disconnected Customer Details</p>
                    </div>
                            
                              
                <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                    <div class="icon"><i class="fa fa-check-circle"></i></div>
                    <h4 class="title"><a href="">Registers</a></h4>
                    <p class="description"> Sales Register
                         Receipt Register
                         Society wise Bill Summary
                         Stop Reading Report
                         Security Deposit Details
                         Disconnected Customer Details</p>
                  </div>
  
                  <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                      <div class="icon"><i class="fa fa-check-circle"></i></div>
                      <h4 class="title"><a href="">Auto Email / SMS facility</a></h4>
                      <p class="description"> Online billing facility, 
                        Auto mail and SMS Facility.
                        </p>
                    </div> 
            </div>
          </div>
  
          <div class="row" >
              <div class="col-2" >
             
            </div>
            <div class="col-8" >
                <img src="../assets/img/AccPayScr.png" class="img-fluid" alt="" >
              </div>
              <div class="col-2" >
                  
                </div>
          </div>
      </div>
  </div>
  </section>